<template>
  <div class="text-center">
    <h1
      class="
       text-2xl
       tracking-tight
       font-black
     text-gray-900
       sm:text-3xl
      "
    >
      <span class="block">Success,</span>
      <span class="block text-mygrad">they're yours to keep!</span>
    </h1>
    <p
      class="
         mt-3
         max-w-md
         mx-auto
         text-sm text-gray-700
         sm:text-base
         md:mt-5 md:max-w-3xl
      "
    >
      Thank you for purchasing your event photos.
    </p>
    <p
      class="
       mt-3
         max-w-md
         mx-auto
         text-sm text-gray-700
         sm:text-base
         md:mt-5 md:max-w-3xl
      "
    >
      If your order includes prints, use this reference for collection or delivery support:
      <span><b>{{ nanoID }}</b></span>
    </p>
    <p
      v-if="email"
      class="
        mt-3
         max-w-md
         mx-auto
         text-sm text-gray-700
         sm:text-base
         md:mt-5 md:max-w-3xl
      "
    >
      If your order includes digital photos, they will be sent to {{ email }} for you to download.
    </p>
    <p
      v-else
      class="
        mt-3
         max-w-md
         mx-auto
         text-sm text-gray-700
         sm:text-base
         md:mt-5 md:max-w-3xl
      "
    >
      If your order includes digital photos, they will be sent to the email address used at checkout.
    </p>
    <p
      v-if="downloadUrl"
      class="
        mt-6
         max-w-md
         mx-auto
      "
    >
      <a
        :href="downloadUrl"
        class="inline-flex items-center justify-center px-4 py-2 w-full border border-blue-300 shadow-sm text-lg font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
      >
        Download digital images
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'SnapshotSuccessMessage',
  props: {
      email: String,
      nanoID: String,
      downloadUrl: String,
  }
};
</script>
